class ContractResource {

    public static $inject: string[] = [
        "$resource",
        "configService"
    ];

    constructor(
        $resource,
        configService
    ) {
        return headers => {
            // tslint:disable-next-line:max-line-length
            return $resource( configService.paymentApi.url + "/v1/organizations/:id/contracts", { id: "@id", company_type: "@company_type", provider: "@provider"  }, {
                get: {
                    method: "GET",
                    headers: headers || {}
                }
            });
        };
    }
}

angular
    .module("thor.core.contract.resource", [])
    .factory("contractResource", ContractResource);
